<template>
  <div style="height: 100%; width: 1440px;margin:0 auto;">
    <el-dialog title="Data" :visible.sync="dialogTableVisible" width="60%" align="center">
      <div :hidden="dataLoading">
        <i class="el-icon-loading"></i>
      </div>
      <el-row>
        <div align="center">
          <el-table :data="gridData">
            <el-table-column v-for="col in checkedPvList" :property="col" :label="col" :key="col" width="300"
                             align="center" header-align="center"></el-table-column>
          </el-table>
        </div>
      </el-row>
      <el-row>
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          :page-count="pageNumber"
          :current-page.sync="currentPage"
          @current-change="pageChange" align="center">
        </el-pagination>
      </el-row>
    </el-dialog>
    <el-dialog title="Statistics" :visible.sync="statisticsDialogTableVisible" width="80%" align="center">
      <div :hidden="statisticsLoading">
        <i class="el-icon-loading"></i>
      </div>
      <el-table :data="statisticsData" align="center">
        <el-table-column property="Pv_Name" label="Pv Name"></el-table-column>
        <el-table-column property="Mean" label="Mean"></el-table-column>
        <el-table-column property="Deviation" label="Deviation"></el-table-column>
        <el-table-column property="RMS" label="RMS"></el-table-column>
        <el-table-column property="Max" label="Max"></el-table-column>
        <el-table-column property="Min" label="Min"></el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="Search pvs" :visible.sync="SearchPvsVisible" width="30%" align="left" @close="closeSearch">
      <div style="max-height:300px;overflow-y:auto;">
        <el-input placeholder="Enter Keywords(for example: PSS)" v-model="SearchPvs">
          <el-button slot="append" icon="el-icon-search" @click="searchPvsBtn"></el-button>
        </el-input>
        <el-table ref="pvNameTable" :data="searchPvsData" align="center" @selection-change="selectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="name" label="Pv Name"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-row type="flex" justify="left">
      <el-col :span="5"  style="margin-top: 1%;margin-right:15px;" align="center">
        <div style="margin-bottom:10px;">
            Groups
            <el-button type="primary" @click="addGroup" style="background-color: #004499; border-color: #004499" size="mini"
                      icon="el-icon-plus">Add
            </el-button>
            <el-button type="primary" @click="removeGroup" style="background-color: #004499; border-color: #004499;"
                      size="mini" icon="el-icon-minus">Remove
            </el-button>
            <!--<el-button  type="primary" icon="el-icon-delete" @click="clearGroups" style="background-color: #004499; border-color: #004499" size="mini">Clear</el-button>-->
        </div>
        <div>
          <el-card v-for="(group,index) in groups" :key="index" style="width: 99%; margin-top: 2px" shadow="hover"
                   body-style="padding: '10px'">
            <div style="min-height: 0;  margin-top: auto; margin-bottom: auto" align="center">
              Group{{group.number}} member
              <el-button style="padding: 3px; margin-left: 2px; color: #000; " @click="group.pvs.push({name:''})"
                         icon="el-icon-plus"></el-button>
              <el-button style="padding: 3px; color: #000; " @click="group.pvs.length >1 ? group.pvs.pop():group.pvs" icon="el-icon-minus"></el-button>
              <div align="right">
                <el-button style="padding: 3px; color: #000; " @click="searchPvs(index)" icon="el-icon-search">Search Pvs</el-button>
                <el-checkbox style="margin-right:-13px;" v-model="group.logCheck" align="right">log</el-checkbox>
              </div>
            </div>
            <div style="margin-top: 2px;">
              <input v-for="pv in group.pvs" v-model="pv.name" v-on:input="inputChange(group,pv,$event)"/>
            </div>
          </el-card>
        </div>
      </el-col>

      <el-col :span="17" align="center">
        <div align="center" v-loading="chartLoading" style="margin-top: 3%">
          <div v-if="!isDBPM"><highstock :options='options' style="width: 100%; align: center;"></highstock></div>
          <div v-if="isDBPM">
            <highcharts :options='options' style="width: 100%; align: center;"></highcharts>
          </div>
          <!-- <highstock :options='options' style="width: 100%; align: center;"></highstock> -->
          
          <div style="height:30px;margin-top:10px;margin-left:10px;text-align: center;" class="timepoint" v-if="isDBPM">
            <ul class="timeline">
              <li class="timeline-item" v-for="(item,index) in timeArray" :key="index" :timestamp="item.timestamp" @click="clickItem(item)">
                <div class="timeline-tail"></div>
                <div class="timeline-dot"></div>
                <div class="timeline-content">
                  {{index}}
                </div>
              </li>
              <!-- <li v-for="(item,index) in timeArray" :key="index" :timestamp="item.timestamp" @click="clickItem(item)">
                <div class=" timeline-content">
                  {{ item.timestamp}}
                </div>
              </li> -->
            </ul>
          </div> 
        </div>
        <div style="margin-top:10px;">
          <div v-if="false" style="display: inline-block;margin-right: 0.5%;font-size: 14px;">Data Source:</div>
          <el-select v-if="false" v-model="daSourceValue" placeholder="请选择" style="width:150px;" @change="changeDataSource">
            <el-option
            v-for="item in dataSources"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            >
            </el-option>
          </el-select>
          <el-date-picker v-if = "isDBPM"
            v-model="value6"
            type="datetime"
            align="right"
            style="width:400px;"
          >
          </el-date-picker>
          <el-date-picker v-if = "!isDBPM"
            v-model="value5"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="to"
            start-placeholder="start time"
            end-placeholder="end time"
            align="right"
            style="width:400px;"
          >
          </el-date-picker>
          <div style="display: inline-block;margin-right: 1%;font-size: 14px;" v-if="!isDBPM">Aggregate Type:</div>
          <div style="display:inline-block;" v-if="!isDBPM">
            <el-select v-model="ppValue" placeholder="请选择" style="width:150px;" :disabled = "isDisabled">
            <el-option
            v-for="item in ppOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            >
            </el-option>
          </el-select>
          </div>
         
        </div>
        <div class="block" style="margin-top: 1%;" align="center">
          <!--<span class="demonstration">选择查询时间段</span><br/>-->
        </div>
        <div style="margin-top: 1%" align="center">
          <el-button v-on:click="query1" type="primary" style="background-color: #004499; border-color: #004499"
                     :disabled="queryDisabled">Draw Line Chart
          </el-button>
          <el-button v-on:click="showStatistics" type="primary" v-if="!isDBPM"
                     style="background-color: #004499; border-color: #004499">Statistics Data
          </el-button>
          <el-button @click="showData" type="primary" style="background-color: #004499; border-color: #004499" v-if="!isDBPM">View
            Data
          </el-button>
          <el-button v-on:click="downloadData" type="primary" style="background-color: #004499; border-color: #004499"
                     :disabled="downloadDisabled">Download Data
          </el-button>
          <el-button v-on:click="liveData" type="primary" style="background-color: #004499; border-color: #004499" v-if="!isDBPM"
                     :disabled="queryDisabled">Live
          </el-button>
        </div>
        <div style="margin-top: 1%;margin-left: auto;margin-right: auto;font-size: small;" align="center" v-if="!isDBPM">
          <el-switch
            active-color="#13ce66"
            inactive-color="#696969"
            active-text="Logarithmic"
            v-model="switchValue1"
            @change="changeChartType">
          </el-switch>
          <el-switch
            active-color="#13ce66"
            inactive-color="#696969"
            active-text="Beam Current"
            v-model="switchValue2"
            @change="addBeamCurrSeries">
          </el-switch>
          <el-switch
              active-color="#13ce66"
              inactive-color="#696969"
              active-text="Refetch Data at Zoom"
              v-model="switchValue3"
              @change="changeSelectType">
            </el-switch>
          <div style="width: 30%; margin-top: 10px" :hidden="progressHidden" align="center">
            <!--<font>正在下载第{{downloadSeries}}个PV</font>-->
            <!-- <el-progress :text-inside="true" :stroke-width="18" :percentage="percentage"></el-progress> -->
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "userdefinedquery",
    data() {
      return {
        queryDisabled: false,
        statisticsDisabled: false,
        dataDisabled: false,
        downloadDisabled: false,

        //Loading
        statisticsLoading: true,
        dataLoading: true,
        chartLoading: false,

        downloadSeries: 1,

        progressHidden: true,
        percentage: 0,

        timer: null,

        groups: [{number: 1, pvs: [{name: ''}], logCheck: false}],

        showHeader: false,
        gridData: [{pvName: 'RNG:BEAM:CURR'}, {pvName: 'RNG:BEAM:LIFE'}],
        isHidden: false,
        options: {
          chart: {
            width: 1000,
            height: 550,
            zoomType: 'x',
            resetZoomButton: {
              position: {
                // align: 'right', // by default
                // verticalAlign: 'top', // by default
                x: 0,
                y: 0
              },
              relativeTo: 'chart',
            },
            animation: false,
            plotBorderWidth: 1,
            plotBorderColor: 'grey',
            marginTop:20  
          },
          exporting:{
            enabled:true,
            buttons:{
              contextButton: {
                enabled: false
              },
              test:{
                x:-5,
                y:12,
                text:'reset',
                titleKey:'reset',
                // symbol:'circle',
                onclick:this.resetChart,
                hoverSymbolFill:null,
                theme:{
                  stroke:'silver',
                  states:{
                    hover:{
                      fill:'#e6e6e6'
                    },
                    select:{
                      stroke:'#039',
                      fill:'#bada55'
                    }
                  }
                }
              }
            }
          },
          colors: ['#FF0000', '#434348', '#90ed7d', '#f7a35c', '#8085e9',
            '#f15c80', '#e4d354', '#8085e8', '#8d4653', '#91e8e1'],
          plotOptions: {
            series: {
              turboThreshold: 10000,
              animation: false
            },
            line: {
              dataGrouping: {
                enabled: false
              }
            }
          },
          noData: {
            style: {
              fontWeight: 'bold',
              fontSize: '15px',
              color: '#303030'
            }
          },
          title: {
            text: null
          },
          xAxis: {
            showFirstLabel: true,
            showLastLabel: true,
            gridLineDashStyle: 'ShortDash',
            gridLineWidth: 1,
            ordinal: false,
            title: {
              text: 'Time',
              style: {
                color: "black",
                fontWeight: 1000
              }
            },
            // type: 'datetime',
            dateTimeLabelFormats: {
              millisecond: '%H:%M:%S.%L',
              second: '%H:%M:%S',
              minute: '%H:%M',
              hour: '%H:%M',
              day: '%m-%d',
              week: '%m-%d',
              month: '%Y-%m',
              year: '%Y'
            },
            lineColor: 'black',
            events:{
              afterSetExtremes:this.afterSetExtremes
            }
          },
          navigation: {
            buttonOptions:{
              align:'right',
              y:12
            }
          },
          yAxis: [],
          lang: {
            downloadCSV: '下载CSV文件',
            noData: "no data"
          },
          tooltip: {
            dateTimeLabelFormats: {
              millisecond: '%m-%d %H:%M:%S.%L',
              second: '%m-%d %H:%M:%S',
              minute: '%m-%d %H:%M',
              hour: '%m-%d %H:%M',
              day: '%Y-%m-%d %H:%M',
              week: '%m-%d %H:%M',
              month: '%Y-%m',
              year: '%Y-%m-%d'
            }
          },
          credits: {
            enabled: false,
          },
          rangeSelector: false,
          legend: {
            enabled: true,
            verticalAlign: 'bottom',
            // layout: 'vertical',
            align: 'middle',
            layout: 'horizontal',
            maxHeight: 40
          },
          series: []
        },
        switchValue1: false,
        switchValue2: false,
        switchValue3: true,
        pickerOptions: {
          shortcuts: [{
            text: '最近一天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近30天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近90天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        value5: [new Date(Date.now() - 3600 * 24 * 1000), new Date(Date.now())],
        value6:new Date(Date.now()),
        dialogTableVisible: false,

        statisticsDialogTableVisible: false,
        statisticsData: [],

        checkedPvList: [],
        //分页属性
        //使用懒加载，加载一页，显示一页
        pageNumber: 0,
        pageSize: 100,
        currentPage: 1,
        //Aggregate Type的下拉框
        ppOptions:[{
          value:'avg',
          label:'avg'
        },{
          value:'min',
          label:'min'
        },{
          value:'max',
          label:'max'
        }],
        ppOptionsCopy:[{
          value:'First Sample',
          label:'First Sample'
        },{
          value:'Mean',
          label:'Mean'
        },{
          value:'Min',
          label:'Min'
        },{
          value:'Max',
          label:'Max'
        }],
        //选择的Aggregate Type的值
        ppValue:"avg",
        timeMin:null,
        timeMax:null,
        //data source的下拉框
        dataSources:[{
          value:'HBase',
          label:'HBase'
        },{
          value:'AA',
          label:'AA'
        },{
          value:'Oracle',
          label:'Oracle'
        }],
        daSourceValue:'HBase',
        isDisabled:false,
        SearchPvsVisible:false,
        SearchPvs:'',
        limit:1000,
        searchPvsData:[],
        searchPvsData2:[],
        selectIndex:0,
        dianping:["BL01B:WM0:Status","BL03U:WM0:Status","BL04B:WM0:Status","BL07W:WM0:Status","BL08B:WM0:Status","BL09U:WM0:Status","BL10B:WM0:Status","BL11U:WM0:Status","BL12:WM0:Status","BL12B:BS:Status","BL12C:BS:Status","BL13U:WM0:Status"],
        timer:null,
        LiveDate1:null,
        LiveDate2:null,
        startLiveTime:null,
        chart:null,
        isDBPM:false,
        timeArray:[],
        time3:null,
      }
    },
    methods: {
        inputChange: function (group, pv, $event) {
        // console.log($event);
        this.timeMin = null;
        this.timeMax = null;
        this.ppValue = "avg";
        if(pv.name == "SR-BD-DBPM01:bpm1:fa.X" || pv.name == "SR-BD-DBPM03:bpm2:fa.X"){
          this.isDBPM = true;
        }else{
          this.isDBPM = false;
        }
        let str = $event.path[0].value.replace(/(^\s*)|(\s*$)/g, '');
        if (str != null && str != '') {
          pv.name = str;
        }
      },
      handleClick(index, rows) {
        rows.splice(index, 1);
      },
      query1: function (flag) {
        let _this = this;
        _this.clearInter();
        if (this.groups.length == 1 && (this.groups[0].pvs.length === 1 && this.groups[0].pvs[0] == '')) {
          return;
        }
        if(flag == 'select'){
          this.switchValue2 = true;
        }else{
          this.switchValue2 = false;
        }
        if (this.daSourceValue !== "Oracle" && this.ppValue === "") {
          this.$confirm("请选择需要查询的Aggregate Type", "提示", {
            showCancelButton: false,
            showConfirmButton: false,
          })
          return;
        }
        let count = 0;
        this.options.yAxis = [];
        this.options.series = [];
        this.checkedPvList = [];
        let date1 = new Date(this.value5[0]);
        let date2 = new Date(this.value5[1]);
        if(this.switchValue3 &&  this.timeMin && this.timeMax){
          date1 = new Date(this.timeMin);
          date2 = new Date(this.timeMax);
        }
        let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
        let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
        this.queryDisabled = true;
        this.chartLoading = false;
        let pvList = "";
        let checkedPvList = [];
        for (let i = 0; i < this.groups.length; i++) {
          if (this.groups[i].pvs[0].name === '') {
            this.$confirm("请输入需要查询的PV", "提示", {
              showCancelButton: false,
              showConfirmButton: false,
            })
            this.chartLoading = false;
            this.queryDisabled = false;
            return;
          }
        }
        for (let i = 0; i < this.groups.length; i++) {
          let yType = this.groups[i].logCheck ? "logarithmic" : "linear";
          this.options.yAxis.push({
            showFirstLabel: true,
            showLastLabel: true,
            // gridLineDashStyle:'ShortDash',
            gridLineWidth: 0,
            title: {
              text: null,
              style: {
                color: "black",
                fontWeight: 1000
              }
            },
            type: yType,
            opposite: false,
            lineWidth: 2
          })
          this.$axios.get('/hlsTS/pvunit/' + this.groups[i].pvs[0].name)
            .then(function (response) {
              if (response.data === null || response.data == "unknown") {
                _this.options.yAxis[i].title.text = _this.groups[i].pvs[0].name
              } else {
                _this.options.yAxis[i].title.text = response.data
              }
            })
        }
        for (let i = 0; i < this.groups.length; i++) {
          for (let j = 0; j < this.groups[i].pvs.length; j++) {
            if (this.groups[i].pvs[j].name !== '') {
              pvList = pvList + this.groups[i].pvs[j].name + "@";
              checkedPvList.push(this.groups[i].pvs[j].name);
              count++;
              this.options.series.push({
                name: _this.groups[i].pvs[j].name,
                data: null,
                yAxis: i,
                type: 'line',
                lineWidth: 1.5
              })
            }
          }
        }
        let failedPvList = []
        let emptyPvList = []
        if(pvList == "SR-BD-DBPM01:bpm1:fa.X@" || pvList == "SR-BD-DBPM03:bpm2:fa.X@"){
          let date3 = new Date(this.value6);
          let date4 = new Date(this.value6).getTime() + 1000;
          let time3 = date3.format("yyyy-MM-dd hh:mm:ss");
          _this.time3 = time3;
          let time4 = new Date(date4).format("yyyy-MM-dd hh:mm:ss").toString();
          this.$axios.get("/hlsTS/history_timepoint1/name/"+ pvList.replace(/@/g, '') + "/" + time3 + "/" + time4)
              .then(function (response) {
                let timeData = response.data;
                let timeDataP = [];
                _this.timeArray = [];
                _this.timePointArr = [];
                for(let i=0;i<timeData.length;i++){
                  let obj = {
                    // timestamp:new Date(_this.shijianchuo(timeData[i].timestamp)).format("yyyy-MM-dd hh:mm:ss.S").toString(),
                    timestamp:timeData[i].timestamp,
                    nanosecs:timeData[i].nanosecs
                  }
                  let obj1 = {
                    pvName:pvList.replace(/@/g, ''),
                    timestamp:new Date(_this.shijianchuo1(timeData[i].timestamp)).format("yyyy-MM-dd hh:mm:ss.S").toString(),
                    // timestamp1:timeData[i].timestamp,
                    nanosecs:timeData[i].nanosecs
                  }
                  _this.timeArray.push(obj1);
                  timeDataP.push([_this.shijianchuo1(obj.timestamp),i*0.01])
                }
                // _this.options.series[0].data = timeDataP;
                _this.queryDisabled = false;
              })
        }else{
          _this.options.xAxis.opposite = false;
          _this.options.exporting.enabled = true;
          //this.$axios.get("/hlsTS/history/nameMap/" + pvList  + '/' + this.ppValue + "/" + time1 + "/" + time2)
          this.$axios.post("/hlsTS/history/nameMap",{
              pvList: pvList,
              type: this.ppValue,
              startTime: time1,
              endTime: time2
            }).then(function (response1) {
                // _this.options.xAxis.title.text= 'Time';
                if (response1.status !== 200) {
                  _this.$notify.error({
                    title: '错误',
                    message: 'PV' + _this.groups[i].pvs[j].name + "请求出现异常",
                    position: 'top-right',
                    offset: 400,
                    duration: 3000
                  });
                  _this.queryDisabled = false;
                  _this.chartLoading = false;
                  return;
                }
                if (response1.data == null) {
                  _this.$notify.error({
                    title: '错误',
                    message: 'PV ' + name + " 查询结果为空",
                    position: 'top-right',
                    offset: 400,
                    duration: 3000
                  });
                  if (--count === 0) {
                    _this.queryDisabled = false;
                    _this.chartLoading = false;
                  }
                  return;
                }
                console.log('checkedPvList',checkedPvList)
                for (let i = 0; i < checkedPvList.length; i++) {
                  let name = checkedPvList[i];
                  //let index = _this.dianping.indexOf(name);
                  //if(index !== -1){
                  if(response1.data[name].is_state){
                    _this.options.series[i].step = 'left';
                  }else{
                    _this.options.series[i].step = '';
                  }
                  if (response1.data[name].data == null || response1.data[name].data.length === 0) {
                    emptyPvList.push(name)
                    continue;
                  }
                  let p = new Array();
                  date1.setMilliseconds(0);
                  date2.setMilliseconds(999);
                  if(shijianchuo(response1.data[name].data[0].timestamp.substring(0,13)) <= date1.getTime()){
                    if(response1.data[name].data[0].float_val != null){
                      p.push([date1.getTime(), response1.data[name].data[0].float_val]);
                      if (response1.data[name].data[0].float_val != null) {
                        for (let k = 1; k < response1.data[name].data.length - 1; k++) {
                          let str = response1.data[name].data[k].timestamp;
                          
                          p.push([shijianchuo(str.substring(0,13)),response1.data[name].data[k].float_val]); 
                        }
                      }
                      p.push([date2.getTime(), response1.data[name].data[response1.data[name].data.length-1].float_val]);
                    }
                    if((response1.data[name].data[0].float_val == null || response1.data[name].data[0].float_val == 'null') && response1.data[name].data[0].num_val == null ){
                       p.push([date1.getTime(), response1.data[name].data[1].float_val]);
                      if (response1.data[name].data[1].float_val != null) {
                        for (let k = 2; k < response1.data[name].data.length - 1; k++) {
                          let str = response1.data[name].data[k].timestamp;
                          
                          p.push([shijianchuo(str.substring(0,13)),response1.data[name].data[k].float_val]); 
                        }
                      }
                      p.push([date2.getTime(), response1.data[name].data[response1.data[name].data.length-1].float_val]);
                    }
                    if(response1.data[name].data[0].num_val != null){
                      p.push([date1.getTime(), response1.data[name].data[0].num_val]);
                      if (response1.data[name].data[0].num_val != null) {
                        for (let k = 1; k < response1.data[name].data.length - 1; k++) {
                          let str = response1.data[name].data[k].timestamp;
                          
                          p.push([shijianchuo(str.substring(0,13)),response1.data[name].data[k].num_val]); 
                        }
                      }
                      p.push([date2.getTime(), response1.data[name].data[response1.data[name].data.length-1].num_val]);
                    }
                    
                  }else if(shijianchuo(response1.data[name].data[0].timestamp.substring(0,13)) > date1.getTime()){
                    if(response1.data[name].data[0].float_val != null){
                      p.push([date1.getTime(), null]);
                      if (response1.data[name].data[0].float_val != null && response1.data[name].data.length > 1) {
                        for (let k = 0; k < response1.data[name].data.length; k++) {
                          let str = response1.data[name].data[k].timestamp;
                          
                          p.push([shijianchuo(str.substring(0,13)),response1.data[name].data[k].float_val]); 
                        }
                      }
                      p.push([date2.getTime(), response1.data[name].data[response1.data[name].data.length-1].float_val]);
                    }
                    if(response1.data[name].data[0].num_val != null){
                      p.push([date1.getTime(), null]);
                      if (response1.data[name].data[0].num_val != null && response1.data[name].data.length > 1) {
                        for (let k = 0; k < response1.data[name].data.length; k++) {
                          let str = response1.data[name].data[k].timestamp;
                          
                          p.push([shijianchuo(str.substring(0,13)),response1.data[name].data[k].num_val]); 
                        }
                      }
                      p.push([date2.getTime(), response1.data[name].data[response1.data[name].data.length-1].num_val]);
                    }
                    
                  }
                  
                  _this.options.xAxis.title.text = response1.data[name].data[0].t;
                  _this.options.series[i].data = p;
                }
                _this.queryDisabled = false;
                _this.chartLoading = false;
                alertInfo(failedPvList, emptyPvList);
                return
              })
            .catch(function (error) {
                 _this.queryDisabled = false;
            });
        }
            
        function shijianchuo(str){
          var timestamp = parseInt(str,10);
          var date = new Date(timestamp);
          return date.getTime();
        }
        function alertInfo(failedPvList, emptyPvList) {
          if (failedPvList.length !== 0) {
            let str = "";
            for (let j = 0; j < failedPvList.length; j++) {
              if (j < 10) {
                str += failedPvList[j] + "\n";
                continue
              }
              if (j === 10) {
                str += '等' + failedPvList.length + '个PV';
                break;
              }
            }
            _this.$notify.error({
              title: 'error',
              message: '查询' + str + "失败",
              position: 'top-right',
              offset: 400,
              duration: 3000
            })
          }
          if (emptyPvList.length !== 0) {
            let str = "";
            for (let j = 0; j < emptyPvList.length; j++) {
              if (j < 10) {
                str += emptyPvList[j] + "\n";
                continue
              }
              if (j === 10) {
                str += '等' + emptyPvList.length + '个PV';
                break;
              }
            }
            _this.$notify.error({
              title: 'error',
              message: str + "查询结果为空",
              position: 'top-right',
              offset: 400,
              duration: 3000
            })
          }
        }
      },
      addBeamCurrSeries: function (min,max) {
        if (this.switchValue2 === true) {
          if (this.options.series.length < 1) {
            return;
          }
          this.chartLoading = true;
          let p = [];
          let date1 = new Date(this.value5[0]);
          let date2 = new Date(this.value5[1]);
          let _this = this;
          if(this.switchValue3 && min && max){
            date1 = new Date(min);
            date2 = new Date(max);
          }
          let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
          let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
          
              this.$axios.get('/hlsTS/history/id/617/' + ' ' + '/' + time1 + '/' + time2)
              .then(function (response) {
                let n = response.data.length;
                _this.options.yAxis.push({
                  // gridLineDashStyle:'ShortDash',
                  gridLineWidth: 0,
                  opposite: true,
                  type: 'linear',
                  title: {
                    text: 'BeamCurrent(mA)',
                    style: {
                      color: "black",
                      fontWeight: 4000
                    }
                  },
                  showFirstLabel: true,
                  showLastLabel: true,
                  min: 0,
                  startOnTick: false,
                  // max:380,
                  lineWidth: 2
                });
                let yAxisPosition = _this.options.yAxis.length - 1;

                date1.setMilliseconds(0);
                date2.setMilliseconds(999);
                if(_this.shijianchuo1(response.data[0].timestamp.substring(0,13)) <= date1.getTime()){
                  p.push([date1.getTime(), response.data[0].float_val])
                  for (let i = 1; i < n -1; i++) {
                    let str = response.data[i].timestamp;
                    p.push([_this.shijianchuo1(str.substring(0,13)), response.data[i].float_val]);
                  }
                  p.push([date2.getTime(), response.data[n - 1].float_val]); 
                }else if(_this.shijianchuo1(response.data[0].timestamp.substring(0,13)) > date1.getTime()){
                  p.push([date1.getTime(), null])
                  if (response.data[0].float_val != null && response.data.length > 1) {
                    for (let i = 0; i < n ; i++) {
                      let str = response.data[i].timestamp;
                      p.push([_this.shijianchuo1(str.substring(0,13)), response.data[i].float_val]);
                    }
                  }
                  p.push([date2.getTime(), response.data[n - 1].float_val]); 
                }
                // for (var i = 0; i < n; i++) {
                //   let str = response.data[i].timestamp;
                //   p.push([_this.shijianchuo1(str.substring(0,13)), response.data[i].float_val]);
                // }
                _this.options.series.push({
                  name: 'RNG:BEAM:CURR',
                  data: p,
                  color: "#0055fa",
                  yAxis: yAxisPosition
                })
                _this.chartLoading = false;
              })
          } else if (this.switchValue2 === false) {
              if (this.options.yAxis[this.options.yAxis.length - 1].title.text === "BeamCurrent(mA)"
                && this.options.yAxis[this.options.yAxis.length - 1].opposite === true) {
                this.options.yAxis.pop();
                this.options.series.pop();
              }
          }
      },
      changeChartType: function () {
        if (this.switchValue1 === true) {
          for (let i = 0; i < this.options.yAxis.length; i++) {
            if (this.options.yAxis[this.options.yAxis.length - 1].title.text === "BeamCurrent(mA)"
              && this.options.yAxis[this.options.yAxis.length - 1].opposite === true) {
              continue;
            }
            this.options.yAxis[i].type = 'logarithmic';
          }
        } else if (this.switchValue1 === false) {
          for (let i = 0; i < this.options.yAxis.length; i++) {
            this.options.yAxis[i].type = 'linear';
          }
        }
      },
      changeSelectType:function(){
        if(this.switchValue3 === true){
          this.options.xAxis.events = {
              afterSetExtremes:this.afterSetExtremes
            }
        }else{
          delete this.options.xAxis.events;
        }
        this.resetChart();
      },
      showStatistics: function () {
        this.clearInter();
        let count = 0;
        this.statisticsData = []
        this.statisticsLoading = false;
        this.statisticsDialogTableVisible = false;
        let date1 = new Date(this.value5[0]);
        let date2 = new Date(this.value5[1]);
        if(this.switchValue3 &&  this.timeMin && this.timeMax){
          date1 = new Date(this.timeMin);
          date2 = new Date(this.timeMax);
        }
        let _this = this;
        let checkedPvList = []
        let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
        let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
        let pvList = ""
        let failedPvList = []
        let emptyPvList = []
        for (let i = 0; i < this.groups.length; i++) {
          for (let j = 0; j < this.groups[i].pvs.length; j++) {
            if (this.groups[i].pvs[j].name !== '') {
              count++;
              checkedPvList.push(this.groups[i].pvs[j].name);
              pvList = pvList + this.groups[i].pvs[j].name + "@";
            }
          }
        }
        if (count === 0) {
          this.$confirm("请输入需要查询的PV", "提示", {
            showCancelButton: false,
            showConfirmButton: false,
          })
          this.statisticsLoading = true;
          return;
        }
        this.statisticsDialogTableVisible = true;
        for (let i = 0; i < checkedPvList.length; i++) {
          this.statisticsData.push({
            Pv_Name: checkedPvList[i],
            Mean: null,
            Deviation: null,
            RMS: null,
            Max: null,
            Min: null
          })
        }
        
            this.$axios.get('/hlsTS/history/statisticsMap/' + pvList + '/' + time1 + '/' + time2)
            .then(function (response) {
              if (response.data == null) {
                _this.$notify.error({
                  title: '错误',
                  message: 'PV ' + _this.groups[i].pvs[j].name + '统计信息查询结果为空',
                  position: 'top-right',
                  offset: 400,
                  duration: 3000
                });
                _this.statisticsLoading = true;
                return;
              }
              for (let i = 0; i < checkedPvList.length; i++) {
                let name = checkedPvList[i];
                if (response.data[name] === null || response.data[name].length === 0) {
                  emptyPvList.push(name)
                  continue;
                }

                _this.statisticsData[i].Mean = response.data[name].Mean !== null ? response.data[name].Mean.toFixed(6) : null;
                _this.statisticsData[i].Deviation =response.data[name].Deviation !== null ? response.data[name].Deviation.toFixed(6) : null;
                _this.statisticsData[i].RMS = response.data[name].RMS !== null ? response.data[name].RMS.toFixed(6) : null;
                _this.statisticsData[i].Max = response.data[name].Max !== null ? response.data[name].Max.toFixed(6) : null;
                _this.statisticsData[i].Min = response.data[name].Min !== null ? response.data[name].Min.toFixed(6) : null;
              }
              _this.statisticsLoading = true
              alertInfo(failedPvList, emptyPvList);
            })
        function alertInfo(failedPvList, emptyPvList) {
          if (failedPvList.length !== 0) {
            let str = "";
            for (let j = 0; j < failedPvList.length; j++) {
              if (j < 10) {
                str += failedPvList[j] + "\n";
                continue
              }
              if (j === 10) {
                str += '等' + failedPvList.length + '个PV';
                break;
              }
            }
            _this.$notify.error({
              title: 'error',
              message: '查询' + str + "失败",
              position: 'top-right',
              offset: 400,
              duration: 3000
            })
          }
          if (emptyPvList.length !== 0) {
            let str = "";
            for (let j = 0; j < emptyPvList.length; j++) {
              if (j < 10) {
                str += emptyPvList[j] + "\n";
                continue
              }
              if (j === 10) {
                str += '等' + emptyPvList.length + '个PV';
                break;
              }
            }
            _this.$notify.error({
              title: 'error',
              message: str + "查询结果为空",
              position: 'top-right',
              offset: 400,
              duration: 3000
            })
          }
        }
      },
      addGroup: function () {
        if (this.groups === null || this.groups.length === 0) {
          this.groups.push({
            number: '1',
            pvs: [],
            logCheck: false
          });
          return;
        }
        this.groups.push({
          number: parseInt(this.groups[this.groups.length - 1].number) + 1,
          pvs: [{name: ''}],
          logCheck: false
        })
      },
      removeGroup: function () {
        if (this.groups.length > 1) {
          this.groups.pop();
        }
      },
      clearGroups: function () {
        // let firstName = this.groups[1].pvs[0].name
        this.groups = new Array();
        this.groups.push({number: 1, pvs: [{name: ''}], logCheck: false});
      },
      showData: function () {
        this.clearInter();
        this.checkedPvList = [];
        this.dialogTableVisible = false;
        this.currentPage = 1;
        this.pageNumber = 1;
        this.gridData = [];
        let row = {}
        let pvList = "";
        let pv = "";
        let count = 0;
        let date1 = new Date(this.value5[0]);
        let date2 = new Date(this.value5[1]);
        if(this.switchValue3 &&  this.timeMin && this.timeMax){
          date1 = new Date(this.timeMin);
          date2 = new Date(this.timeMax);
        }
        let _this = this;
        let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
        let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
        for (let i = 0; i < this.groups.length; i++) {
          for (let j = 0; j < this.groups[i].pvs.length; j++) {
            if (this.groups[i].pvs[j] != null && this.groups[i].pvs[j].name != null && this.groups[i].pvs[j].name != "") {
              row[this.groups[i].pvs[j].name] = "";
              this.checkedPvList.push(this.groups[i].pvs[j].name);
              pv = this.groups[i].pvs[j].name;
              pvList = pvList + pv + "@";
            }
          }
        }
        for (let i = 0; i < this.groups.length; i++) {
          for (let j = 0; j < this.groups[i].pvs.length; j++) {
            if (this.groups[i].pvs[j].name !== '') {
              count++;
            }
          }
        }
        if (count !== 0) {
          this.dataLoading = false;
        } else {
          this.$confirm("请选择需要查询的PV", "提示", {
            showCancelButton: false,
            showConfirmButton: false,
          })
          return;
        }
        this.dialogTableVisible = true;
        for (let i = 0; i < this.pageSize; i++) {
          this.gridData.push(Object.assign({}, row));
        }
        
            //this.$axios.get("/hlsTS/history/page/count/" + pvList + "/" + time1 + "/" + time2)
            this.$axios.post("/hlsTS/history/page/count",{
              nameList: pvList,
              startTime: time1,
              endTime: time2
            }).then(function (response) {
                // if (response.data === 0) {
                //   this.$notify.error({
                //     title: '错误',
                //     message: '查询结果为空',
                //     position: 'top-right',
                //     offset: 400
                //   })
                // }
                _this.pageNumber = Math.ceil(response.data % _this.pageSize ? response.data / _this.pageSize : response.data / _this.pageSize + 1);
              })
              
              let val = 1;
              for (let i = 0; i < this.checkedPvList.length; i++) {
              
                this.$axios.get('/hlsTS/history/page/' + val + '/' + this.pageSize + '/' + this.checkedPvList[i] + '/' + time1 + '/' + time2)
                  .then(function (response) {
                    if (response.data == null || response.data === "") {
                      if (--count === 0) {
                        _this.dataLoading = true;
                      }
                      return;
                    }
                    if (response.data[0].float_val != null) {
                      for (let j = 0; j < response.data.length; j++) {
                        
                        let timeStamp = _this.shijianchuo1(response.data[j].timestamp.substring(0,13));
                        let time = new Date(timeStamp).format("yyyy-MM-dd hh:mm:ss.S");
                        let a = response.data[j].float_val;
                        if(Math.abs(response.data[j].float_val) < 0.1 && Math.abs(response.data[j].float_val) > 1e-10) {
                         
                          _this.gridData[j][_this.checkedPvList[i]] = time.toString() + "\r\n\r\r\r\n" + response.data[j].float_val.toPrecision(6);
                        } else {
                          //_this.gridData[j][_this.checkedPvList[i]] = time.toString() + "\r\n\r\r\r\n" + response.data[j].float_val.toFixed(6);
                          _this.gridData[j][_this.checkedPvList[i]] = time.toString() + "\r\n\r\r\r\n" + response.data[j].float_val;
                        }
                      }
                    } else {
                      for (let j = 0; j < response.data.length; j++) {
                        let timeStamp = _this.shijianchuo1(response.data[j].timestamp.substring(0,13));
                        let time = new Date(timeStamp).format("yyyy-MM-dd hh:mm:ss.S");
                        _this.gridData[j][_this.checkedPvList[i]] = time.toString() + "\r\n\r\r\r\n" + response.data[j].num_val;
                      }
                    }
                    if (--count === 0) {
                      _this.dataLoading = true;
                    }
                  }).catch(function (error) {
                  if (--count === 0) {
                    _this.dataLoading = true
                  }
                });
              }
        },
      shijianchuo1:function(str){
          var timestamp = parseInt(str,10);
          var date = new Date(timestamp);
          return date.getTime();
      },
      pageChange: function (val) {
        let count = 0
        this.gridData = []
        this.dataLoading = false;
        let date1 = new Date(this.value5[0]);
        let date2 = new Date(this.value5[1]);
        let _this = this;
        if(this.switchValue3 && this.timeMin && this.timeMax){
          date1 = new Date(this.timeMin);
          date2 = new Date(this.timeMax);
        }
        let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
        let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
        this.currentPage = val;
        for (let i = 0; i < this.groups.length; i++) {
          for (let j = 0; j < this.groups[i].pvs.length; j++) {
            if (this.groups[i].pvs[j].name !== '') {
              count++;
            }
          }
        }
        let row = {}
        for (let i = 0; i < this.checkedPvList.length; i++) {
          row[this.checkedPvList[i]] = "";
        }
        for (let i = 0; i < this.pageSize; i++) {
          this.gridData.push(Object.assign({}, row));
        }
        
        for (let i = 0; i < this.checkedPvList.length; i++) {
          this.$axios.get('/hlsTS/history/page/' + val + '/' + this.pageSize + '/' + this.checkedPvList[i] + '/' + time1 + '/' + time2)
            .then(function (response) {
              if (response.data == null) {
                if (--count === 0) {
                  _this.dataLoading = true;
                }
                return;
              }
              if (response.data[0].float_val !== null) {
                for (let j = 0; j < response.data.length; j++) {
                  let timeStamp = _this.shijianchuo1(response.data[j].timestamp.substring(0,13));
                  let time = new Date(timeStamp).format("yyyy-MM-dd hh:mm:ss.S");
                  if (Math.abs(response.data[j].float_val) < 0.1) {
                    
                    _this.gridData[j][_this.checkedPvList[i]] = time.toString() + "\r\n\r\r\r\n" +
                      response.data[j].float_val.toPrecision(6);
                  } else {
                    _this.gridData[j][_this.checkedPvList[i]] = time.toString() + "\r\n\r\r\r\n" +
                      response.data[j].float_val.toFixed(6);
                  }
                }
              } else {
                for (let j = 0; j < response.data.length; j++) {
                  let time = new Date(response.data[j].smpl_time).format("yyyy-MM-dd hh:mm:ss.S");
                  _this.gridData[j][this.checkedPvList[i]] = time.toString() + "\r\n\r\r\r\n" +
                    response.data[j].num_val.toPrecision(6);
                }
              }
              if (--count === 0) {
                _this.dataLoading = true;
              }
              return;
            }).catch(function (error) {
            if (--count === 0) {
              _this.dataLoading = true
            }
          });
        }
      },
      downloadData: function () {
        //let _this = this;
        //this.clearInter();
        //this.downloadSeries = 1; // 修复：统一使用数字类型，而非布尔值
        //this.checkedPvList = [];

        // 构建PV列表（前置准备）
        //let pvList = "";
        //for (let i = 0; i < this.groups.length; i++) {
         // let pv = "";
          //for (let j = 0; j < this.groups[i].pvs.length; j++) {
           // if (this.groups[i].pvs[j] != null && this.groups[i].pvs[j].name != null && this.groups[i].pvs[j].name != "") {
             // this.checkedPvList.push(this.groups[i].pvs[j].name);
              //pv = this.groups[i].pvs[j].name;
              //pvList = pvList + pv + "@";
            //}
          //}
        //}

        //if (pvList == null || pvList.length == 0) {
         // this.$confirm("请输入需要下载的PV", "提示", {
            //showCancelButton: false,
            //showConfirmButton: false,
          //});
          //return;
        //}

        // 统一策略：直接使用传统下载（推荐方式），与 customizedquery.vue 保持一致
        this.downloadDataTraditional();
      },

      // 新增：流式下载方法
      downloadDataStream: function () {
        this.clearInter();
        let _this = this;

        this.downloadDisabled = true;
        this.downloadSeries = 1; // 修复：统一使用数字类型
        this.checkedPvList = [];

        let date1 = new Date(this.value5[0]);
        let date2 = new Date(this.value5[1]);
        if(this.switchValue3 && this.timeMin && this.timeMax){
          date1 = new Date(this.timeMin);
          date2 = new Date(this.timeMax);
        }
        let name = new Date(Date.now()).format("yyyy_MM_dd_hh_mm_ss");
        let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
        let time2 = date2.format("yyyy-MM-dd hh:mm:ss");

        // 构建PV列表
        let pvList = "";
        for (let i = 0; i < this.groups.length; i++) {
          let pv = "";
          for (let j = 0; j < this.groups[i].pvs.length; j++) {
            if (this.groups[i].pvs[j] != null && this.groups[i].pvs[j].name != null && this.groups[i].pvs[j].name != "") {
              this.checkedPvList.push(this.groups[i].pvs[j].name);
              pv = this.groups[i].pvs[j].name;
              pvList = pvList + pv + "@";
            }
          }
        }

        // 判断是否为DBPM特殊数据
        let url = '';
        let streamUrl = '';
        let isDBPM = false;
        if(pvList == "SR-BD-DBPM01:bpm1:fa.X@" || pvList == "SR-BD-DBPM03:bpm2:fa.X@"){
          let date3 = new Date(this.value6);
          let date4 = new Date(this.value6).getTime() + 1000;
          let time3 = date3.format("yyyy-MM-dd hh:mm:ss");
          let time4 = new Date(date4).format("yyyy-MM-dd hh:mm:ss").toString();
          time1 = time3;
          time2 = time4;
          url = '/hlsTS/download/DBPM/';
          streamUrl = '/hlsTS/download/stream/DBPM/';
          isDBPM = true;
        } else {
          url = '/hlsTS/download/';
          streamUrl = '/hlsTS/download/stream/';
        }
        //默认流式下载
        _this.downloadDataTraditional();

        // 先获取文件大小估计
        //this.$confirm("正在计算文件大小和下载时间,请勿离开", "提示", {
          //showCancelButton: false,
          //showConfirmButton: false,
          //closeOnClickModal: false,
          //closeOnPressEscape: false,
          //closeOnHashChange: false
        //});

        //this.$axios.get(url + pvList + "/" + time1 + "/" + time2)
         // .then(function (response) {
           // _this.$msgbox.close();
           // _this.$confirm(
             // "Estimated file size " + (response.data / 30000).toFixed(3) + "M, " +
             // "download time:" + (response.data / 40000).toFixed(2) + "s， continue?",
             // "Tips",
             // {
              //  confirmButtonText: 'confirm',
              //  cancelButtonText: 'cancel',
              //  type: 'warning'
              //}
            //).then(() => {
              // 用户确认后，开始流式下载
             // _this.startStreamDownloadUser(streamUrl, time1, time2, name, pvList);
            //}).catch(() => {
             // _this.downloadDisabled = false;
           // });
          //}).catch((error) => {
           // _this.$msgbox.close();
           // _this.downloadDisabled = false;
           // _this.$notify.error({
            //  title: 'Error',
            //  message: '获取文件大小失败: ' + error.message,
            //  duration: 3000
           // });
          //});
      },

      // 新增：执行流式下载（userdefined专用）
      startStreamDownloadUser: function(streamUrl, time1, time2, name, pvList) {
        let _this = this;

        // 创建右上角进度提示框
        let progressBox = document.createElement('div');
        progressBox.id = 'download-progress-' + Date.now();
        progressBox.style.cssText = `
          position: fixed;
          top: 20px;
          right: 20px;
          background: white;
          padding: 16px 20px;
          border-radius: 4px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          z-index: 9999;
          min-width: 300px;
          max-width: 400px;
          border-left: 4px solid #409EFF;
        `;

        let progressContent = document.createElement('div');
        progressContent.innerHTML = `
          <div id="${progressBox.id}-header" style="display: flex; align-items: center; margin-bottom: 8px;">
            <i id="${progressBox.id}-icon" class="el-icon-loading" style="font-size: 18px; color: #409EFF; margin-right: 8px;"></i>
            <strong id="${progressBox.id}-title" style="font-size: 14px; color: #303133;">Downloading...</strong>
          </div>
          <div id="${progressBox.id}-text" style="font-size: 13px; color: #606266; margin-bottom: 8px;">
            Preparing download...
          </div>
          <div id="${progressBox.id}-bar" style="width: 100%; height: 6px; background: #EBEEF5; border-radius: 3px; overflow: hidden; display: none;">
            <div id="${progressBox.id}-bar-inner" style="height: 100%; width: 0%; background: linear-gradient(to right, #409EFF, #66B1FF); transition: width 0.3s ease;"></div>
          </div>
        `;
        progressBox.appendChild(progressContent);
        document.body.appendChild(progressBox);

        let progressTitle = document.getElementById(progressBox.id + '-title');
        let progressIcon = document.getElementById(progressBox.id + '-icon');
        let progressText = document.getElementById(progressBox.id + '-text');
        let progressBar = document.getElementById(progressBox.id + '-bar');
        let progressBarInner = document.getElementById(progressBox.id + '-bar-inner');

        // 使用axios下载流
        this.$axios({
          method: 'get',
          url: streamUrl + time1 + "/" + time2 + "/" + name + "/" + pvList,
          responseType: 'blob',  // 关键：设置响应类型为blob
          timeout: 1800000,  // 30分钟超时（与后端配置匹配）
          onDownloadProgress: function (progressEvent) {
            // 更新下载进度
            if (progressEvent.lengthComputable && progressEvent.total > 0) {
              let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              let downloadedMB = (progressEvent.loaded / 1024 / 1024).toFixed(2);
              let totalMB = (progressEvent.total / 1024 / 1024).toFixed(2);
              if (progressText) {
                progressText.innerHTML = `
                  <div style="margin-bottom: 4px; font-weight: 500;">${percentCompleted}% completed</div>
                  <div style="color: #909399; font-size: 12px;">${downloadedMB} MB / ${totalMB} MB</div>
                `;
              }
              // 显示并更新进度条
              if (progressBar) {
                progressBar.style.display = 'block';
              }
              if (progressBarInner) {
                progressBarInner.style.width = percentCompleted + '%';
              }
            } else {
              // 流式下载时Content-Length可能为0，只显示已下载大小
              let downloadedMB = (progressEvent.loaded / 1024 / 1024).toFixed(2);
              if (progressText) {
                progressText.innerHTML = `
                  <div>Downloaded: ${downloadedMB} MB</div>
                `;
              }
              // 隐藏进度条（无法计算百分比）
              if (progressBar) {
                progressBar.style.display = 'none';
              }
            }
          }
        }).then(function (response) {
          // 下载完成，更新标题和图标
          if (progressTitle) {
            progressTitle.textContent = 'Download completed';
            progressTitle.style.color = '#67C23A';
          }
          if (progressIcon) {
            progressIcon.className = 'el-icon-success';
            progressIcon.style.color = '#67C23A';
          }
          // 更新进度为100%
          if (progressText) {
            let finalSize = (response.data.size / 1024 / 1024).toFixed(2);
            progressText.innerHTML = `
              <div style="margin-bottom: 4px; font-weight: 500; color: #67C23A;">100% completed</div>
              <div style="color: #909399; font-size: 12px;">${finalSize} MB / ${finalSize} MB</div>
            `;
          }
          if (progressBarInner) {
            progressBarInner.style.width = '100%';
            progressBarInner.style.background = 'linear-gradient(to right, #67C23A, #85CE61)';
          }

          // 创建Blob对象
          const blob = new Blob([response.data], { type: 'application/octet-stream' });

          // 创建下载链接
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', name + '.txt');

          // 触发下载
          document.body.appendChild(link);
          link.click();

          // 清理
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          _this.$notify.success({
            title: 'Success',
            message: 'Download completed!',
            duration: 2000,
          });
        }).catch(function (error) {
          console.error('Stream download error:', error);

          _this.$notify.error({
            title: 'Error',
            message: 'Download failed: ' + (error.message || 'Unknown error'),
            duration: 3000,
          });
        }).finally(function () {
          // 延迟移除进度提示框，让用户看到完成状态
          setTimeout(function() {
            if (progressBox && progressBox.parentNode) {
              // 添加淡出动画
              progressBox.style.transition = 'opacity 0.3s';
              progressBox.style.opacity = '0';
              setTimeout(function() {
                if (progressBox.parentNode) {
                  progressBox.parentNode.removeChild(progressBox);
                }
              }, 300);
            }
          }, 800);  // 停留800ms让用户看到100%状态

          _this.downloadDisabled = false;
          _this.progressHidden = true;
        });
      },

      // 保留原有方法，重命名为 downloadDataTraditional
      downloadDataTraditional: function () {
        this.clearInter();
        this.downloadDisabled = true;
        this.downloadSeries = 1; // 修复：统一使用数字类型
        this.checkedPvList = [];
        let date1 = new Date(this.value5[0]);
        let date2 = new Date(this.value5[1]);
        if(this.switchValue3 &&  this.timeMin && this.timeMax){
          date1 = new Date(this.timeMin);
          date2 = new Date(this.timeMax);
        }
        let name = new Date(Date.now()).format("yyyy_MM_dd_hh_mm_ss");
        let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
        let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
        let pvList = "";
        let checkedPvList = this.checkedPvList;
        let _this = this;
        for (let i = 0; i < this.groups.length; i++) {
          let pv = "";
          for (let j = 0; j < this.groups[i].pvs.length; j++) {
            if (this.groups[i].pvs[j] != null && this.groups[i].pvs[j].name != null && this.groups[i].pvs[j].name != "") {
              this.checkedPvList.push(this.groups[i].pvs[j].name);
              pv = this.groups[i].pvs[j].name;
              pvList = pvList + pv + "@";
            }
          }
        }
        this.downloadDisabled = true;
        if (!(pvList == null || pvList.length == 0)) {
          let url = '';
          let urlPvlist = '';
          if(pvList == "SR-BD-DBPM01:bpm1:fa.X@" || pvList == "SR-BD-DBPM03:bpm2:fa.X@"){
            let date3 = new Date(this.value6);
            let date4 = new Date(this.value6).getTime() + 1000;
            let time3 = date3.format("yyyy-MM-dd hh:mm:ss");
            let time4 = new Date(date4).format("yyyy-MM-dd hh:mm:ss").toString();
            time1 = time3;
            time2 = time4;
            url ='/hlsTS/download/count/DBPM/';
            urlPvlist = '/hlsTS/download/DBPM/pvlist';
          }else{
            url ='/hlsTS/download/count';
            urlPvlist = '/hlsTS/download/pvlist';
          }

          // 创建右上角进度提示框
          let progressBox = document.createElement('div');
          progressBox.id = 'download-progress-traditional-' + Date.now();
          progressBox.style.cssText = `
            position: fixed;
            top: 20px;
            right: 10px;
            background: white;
            padding: 16px 20px;
            border-radius: 4px;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            z-index: 9999;
            min-width: 300px;
            max-width: 400px;
            border-left: 4px solid #409EFF;
          `;

          let progressContent = document.createElement('div');
          progressContent.innerHTML = `
            <div id="${progressBox.id}-header" style="display: flex; align-items: center; margin-bottom: 8px;">
              <i id="${progressBox.id}-icon" class="el-icon-loading" style="font-size: 18px; color: #409EFF; margin-right: 8px;"></i>
              <span id="${progressBox.id}-title" style="font-weight: 500; color: #303133;">正在准备下载...</span>
            </div>
            <div id="${progressBox.id}-text" style="color: #606266; font-size: 14px; margin-bottom: 8px;">
              <div>正在计算文件大小...</div>
            </div>
            <div id="${progressBox.id}-bar" style="margin-top: 8px;">
              <div style="background: #EBEEF5; height: 6px; border-radius: 3px; overflow: hidden;">
                <div id="${progressBox.id}-progress" style="background: linear-gradient(to right, #409EFF, #66B1FF); height: 100%; width: 0%; transition: width 0.3s;"></div>
              </div>
            </div>
          `;

          progressBox.appendChild(progressContent);
          document.body.appendChild(progressBox);

          // 保存DOM元素引用
          let progressTitle = document.getElementById(progressBox.id + '-title');
          let progressText = document.getElementById(progressBox.id + '-text');
          let progressBar = document.getElementById(progressBox.id + '-progress');
          let progressIcon = document.getElementById(progressBox.id + '-icon');

          // this.$axios.get(_this.urlFragment + '/download/' + pvList + "/" + time1 + "/" + time2)
          //this.$axios.get( url + pvList + "/" + time1 + "/" + time2)
          this.$axios.post( url,{
            pvList: pvList,
            startTime: time1,
            endTime: time2
          }).then(function (response) {
              //_this.$msgbox.close()

              if (!(pvList == null || pvList.length == 0)) {
                _this.downloadDisabled = true;
                _this.progressHidden = false;

                // 获取总文件大小（字节）
                let totalFileSize = response.data || 0;
                let totalSizeMB = (totalFileSize / 1024 / 1024).toFixed(2);

                // 更新进度框状态为下载中
                if (progressTitle) {
                  progressTitle.textContent = '正在下载中';
                }
                if (progressText) {
                  progressText.innerHTML = `
                    <div style="margin-bottom: 4px;">请勿离开当前页面</div>
                    <div style="color: #909399; font-size: 12px;">已下载：0 MB / ${totalSizeMB} MB</div>
                  `;
                }

                // 开始轮询下载进度
                _this.timer = setInterval(function() {
                  _this.$axios.get( '/hlsTS/download/status/' + name)
                    .then(function (response) {
                      _this.downloadSeries = response.data[0]
                      _this.percentage = response.data[1]

                      // 计算已下载大小
                      let downloadedSize = (totalFileSize * _this.percentage / 100 / 1024 / 1024).toFixed(2);

                      // 更新进度条
                      if (progressBar) {
                        progressBar.style.width = _this.percentage + '%';
                      }
                      if (progressText) {
                        progressText.innerHTML = `
                          <div style="margin-bottom: 4px; font-weight: 500;">${_this.percentage}% 已完成</div>
                          <div style="color: #909399; font-size: 12px;">已下载：${downloadedSize} MB / ${totalSizeMB} MB</div>
                        `;
                      }
                    })
                }, 1000);

                // _this.$axios.get(_this.urlFragment + '/download/' + time1 + "/" + time2 + "/" + name + "/" + pvList)
               //_this.$axios.get(url + time1 + "/" + time2 + "/" + name + "/" + pvList)
               _this.$axios.post(urlPvlist,{
                  startTime: time1,
                  endTime: time2,
                  name: name,
                  pvList: pvList
                }).then(function (response) {
                    // 下载完成
                    if (progressTitle) {
                      progressTitle.textContent = '下载完成';
                      progressTitle.style.color = '#67C23A';
                    }
                    if (progressIcon) {
                      progressIcon.className = 'el-icon-success';
                      progressIcon.style.color = '#67C23A';
                    }
                    if (progressBar) {
                      progressBar.style.width = '100%';
                      progressBar.style.background = '#67C23A';
                    }
                    if (progressText) {
                      progressText.innerHTML = `
                        <div style="margin-bottom: 4px; font-weight: 500; color: #67C23A;">100% 已完成</div>
                        <div style="color: #909399; font-size: 12px;">已下载：${totalSizeMB} MB / ${totalSizeMB} MB</div>
                      `;
                    }

                    // 3秒后自动关闭进度框
                    setTimeout(() => {
                      if (progressBox && progressBox.parentNode) {
                        progressBox.parentNode.removeChild(progressBox);
                      }
                    }, 3000);

                    let str = window.location.href;
                    window.open('http://' + str.split("/")[2] + '/hlsTS/download/media/' + response.data)
                    // window.open('http://' + '222.195.82.88:8081' + '/download/media/'+response.data)
                    _this.progressHidden = true;
                    _this.downloadDisabled = false
                    clearInterval(_this.timer);
                    _this.percentage = 0;
                  })
                  .catch(function(error) {
                    // 下载失败
                    if (progressTitle) {
                      progressTitle.textContent = '下载失败';
                      progressTitle.style.color = '#F56C6C';
                    }
                    if (progressIcon) {
                      progressIcon.className = 'el-icon-error';
                      progressIcon.style.color = '#F56C6C';
                    }
                    if (progressText) {
                      progressText.innerHTML = '<div style="color: #F56C6C;">下载失败，请重试</div>';
                    }

                    // 5秒后自动关闭进度框
                    setTimeout(() => {
                      if (progressBox && progressBox.parentNode) {
                        progressBox.parentNode.removeChild(progressBox);
                      }
                    }, 5000);

                    _this.progressHidden = true;
                    _this.downloadDisabled = false;
                    clearInterval(_this.timer);
                    _this.percentage = 0;
                  });
              }
            })
            .catch(function(error) {
              // 获取文件大小失败
              if (progressTitle) {
                progressTitle.textContent = '准备失败';
                progressTitle.style.color = '#F56C6C';
              }
              if (progressIcon) {
                progressIcon.className = 'el-icon-error';
                progressIcon.style.color = '#F56C6C';
              }
              if (progressText) {
                progressText.innerHTML = '<div style="color: #F56C6C;">准备下载失败，请重试</div>';
              }

              // 5秒后自动关闭进度框
              setTimeout(() => {
                if (progressBox && progressBox.parentNode) {
                  progressBox.parentNode.removeChild(progressBox);
                }
              }, 5000);

              _this.downloadDisabled = false;
            })

        } else {
          this.$confirm("请输入需要下载的PV", "提示", {
            showCancelButton: false,
            showConfirmButton: false,
          })
        }
      },
      //图表框选事件
      afterSetExtremes:function(e){
        this.timeMin = e.min;
        this.timeMax = e.max;
        if(this.switchValue2){
          this.query1('select');
        }else{
          this.query1();
        }
        if(this.switchValue3){
          this.addBeamCurrSeries(e.min,e.max);
        }
      },
      //dataSource下拉框值变化时
      changeDataSource:function(value){
        if(value == "HBase"){
          this.ppValue = "Max"
          this.isDisabled = false
          this.ppOptions = this.ppOptionsCopy
        }else if(value == "AA"){
          this.ppValue = "Max"
          this.isDisabled = false
          this.ppOptions = this.ppOptionsCopy.slice(1)
        }else{
          this.ppValue = ""
          this.isDisabled = true
        }
      },
      searchPvs:function(index){
        if(this.SearchPvsVisible){
          return
        }
        this.selectIndex = index;
        this.SearchPvs = '';
        this.searchPvsData = [];
        this.SearchPvsVisible = true;

      },
      searchPvsBtn:function(){
        this.$axios({ 
                method:'get',
                url:'/hlsTS/getPvName/' + this.SearchPvs
              }).then((response) => {
                if(response.data){
                  let data = response.data;
                  let arr=[];
                  for(let i=0;i<data.length;i++){
                    let obj={
                      name:''
                    }
                    obj.name = data[i].name;
                    arr.push(obj)
                  }
                  this.searchPvsData2 = arr;
                  this.searchPvsData = this.searchPvsData2;
                }
            })
      },
      selectionChange:function(selection){
        if(selection.length != 0){
          this.groups[this.selectIndex].pvs = selection;
        }
      },
      closeSearch:function(){
        this.$refs.pvNameTable.clearSelection();
        this.SearchPvsVisible = false;
      },
      resetChart:function(){
        this.timeMin = null;
        this.timeMax = null;
        //this.ppValue = "avg";
        this.query1();
      },
      getLocaltime:function(){
        let _this = this;
        let date1 = new Date(new Date().getTime() - 5*60*1000);
        let date2 = new Date();
        let livedate1 = null;
        let livedate2 = null;
        livedate1= new Date(date1.getTime());
        livedate2 = new Date(date2.getTime());
        _this.queryLive123(livedate1,livedate2);
      },
      liveData:function(){
        let _this = this;
      
        let livedate2;
        let livedate1;
          let date1 = new Date(new Date().getTime() - 5*60*1000);
          let date2 = new Date();
          _this.startLiveTime = date2;
          livedate1 = new Date(date1.getTime());
          livedate2 = new Date(date2.getTime());
          _this.queryLive(livedate1,livedate2);
          _this.timer = setInterval(()=>{
           _this.getLocaltime()
        },3000);
      },
      queryLive: function (date1,date2) {
        let _this = this;
        if (this.groups.length == 1 && (this.groups[0].pvs.length === 1 && this.groups[0].pvs[0] == '')) {
          return;
        }
        // if(flag == 'select'){
        //   this.switchValue2 = true;
        // }else{
        //   this.switchValue2 = false;
        // }
        if (this.daSourceValue !== "Oracle" && this.ppValue === "") {
          this.$confirm("请选择需要查询的Aggregate Type", "提示", {
            showCancelButton: false,
            showConfirmButton: false,
          })
          return;
        }
        let count = 0;
        this.options.yAxis = [];
        this.options.series = [];
        this.checkedPvList = [];
        // let date1 = new Date(this.value5[0]);
        // let date2 = new Date(this.value5[1]);
        // if(this.switchValue3 &&  this.timeMin && this.timeMax){
        //   date1 = new Date(this.timeMin);
        //   date2 = new Date(this.timeMax);
        // }
        let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
        let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
        this.queryDisabled = true;
        this.chartLoading = false;
        let pvList = "";
        let checkedPvList = [];
        for (let i = 0; i < this.groups.length; i++) {
          if (this.groups[i].pvs[0].name === '') {
            this.$confirm("请输入需要查询的PV", "提示", {
              showCancelButton: false,
              showConfirmButton: false,
            })
            this.chartLoading = false;
            this.queryDisabled = false;
            return;
          }
        }
        for (let i = 0; i < this.groups.length; i++) {
          let yType = this.groups[i].logCheck ? "logarithmic" : "linear";
          this.options.yAxis.push({
            showFirstLabel: true,
            showLastLabel: true,
            // gridLineDashStyle:'ShortDash',
            gridLineWidth: 0,
            title: {
              text: null,
              style: {
                color: "black",
                fontWeight: 1000
              }
            },
            type: yType,
            opposite: false,
            lineWidth: 2
          })
          this.$axios.get('/hlsTS/pvunit/' + this.groups[i].pvs[0].name)
            .then(function (response) {
              if (response.data === null || response.data == "unknown") {
                _this.options.yAxis[i].title.text = _this.groups[i].pvs[0].name
              } else {
                _this.options.yAxis[i].title.text = response.data
              }
            })
        }
        for (let i = 0; i < this.groups.length; i++) {
          for (let j = 0; j < this.groups[i].pvs.length; j++) {
            if (this.groups[i].pvs[j].name !== '') {
              pvList = pvList + this.groups[i].pvs[j].name + "@";
              checkedPvList.push(this.groups[i].pvs[j].name);
              count++;
              this.options.series.push({
                name: _this.groups[i].pvs[j].name,
                data: null,
                yAxis: i,
                type: 'line',
                lineWidth: 1.5
              })
            }
          }
        }
        let failedPvList = []
        let emptyPvList = []
        
            //this.$axios.get("/hlsTS/history/nameMap/" + pvList  + '/' + " " + "/" + time1 + "/" + time2)
            this.$axios.post("/hlsTS/history/nameMap",{
               pvList: pvList,
               type: " ",        // 保留原来的空字符串
               startTime: time1,
               endTime: time2
            }).then(function (response1) {
                // _this.options.xAxis.title.text= 'Time';
                if (response1.status !== 200) {
                  _this.$notify.error({
                    title: '错误',
                    message: 'PV' + _this.groups[i].pvs[j].name + "请求出现异常",
                    position: 'top-right',
                    offset: 400,
                    duration: 3000
                  });
                  _this.queryDisabled = false;
                  _this.chartLoading = false;
                  return;
                }
                if (response1.data == null) {
                  _this.$notify.error({
                    title: '错误',
                    message: 'PV ' + name + " 查询结果为空",
                    position: 'top-right',
                    offset: 400,
                    duration: 3000
                  });
                  if (--count === 0) {
                    _this.queryDisabled = false;
                    _this.chartLoading = false;
                  }
                  return;
                }
                for (let i = 0; i < checkedPvList.length; i++) {
                  let name = checkedPvList[i];
                  //let index = _this.dianping.indexOf(name);
                  //if(index !== -1){
                  if(response1.data[name].is_state){
                    _this.options.series[i].step = 'left';
                  }else{
                    _this.options.series[i].step = '';
                  }
                  if (response1.data[name].data == null || response1.data[name].data.length === 0) {
                    emptyPvList.push(name)
                    continue;
                  }
                  let p = new Array();
                  date1.setMilliseconds(0);
                  date2.setMilliseconds(999);
                  if(shijianchuo(response1.data[name].data[0].timestamp.substring(0,13)) <= date1.getTime()){
                    if(response1.data[name].data[0].float_val != null){
                      p.push([date1.getTime(), response1.data[name].data[0].float_val]);
                      if (response1.data[name].data[0].float_val != null) {
                        for (let k = 1; k < response1.data[name].data.length - 1; k++) {
                          let str = response1.data[name].data[k].timestamp;
                          
                          p.push([shijianchuo(str.substring(0,13)),response1.data[name].data[k].float_val]); 
                        }
                      }
                      p.push([date2.getTime(), response1.data[name].data[response1.data[name].data.length-1].float_val]);
                    }
                    if(response1.data[name].data[0].num_val != null){
                      p.push([date1.getTime(), response1.data[name].data[0].num_val]);
                      if (response1.data[name].data[0].num_val != null) {
                        for (let k = 1; k < response1.data[name].data.length - 1; k++) {
                          let str = response1.data[name].data[k].timestamp;
                          
                          p.push([shijianchuo(str.substring(0,13)),response1.data[name].data[k].num_val]); 
                        }
                      }
                      p.push([date2.getTime(), response1.data[name].data[response1.data[name].data.length-1].num_val]);
                    }
                    
                  }else if(shijianchuo(response1.data[name].data[0].timestamp.substring(0,13)) > date1.getTime()){
                    if(response1.data[name].data[0].float_val != null ){
                      p.push([date1.getTime(), null]);
                      if (response1.data[name].data[0].float_val != null && response1.data[name].data.length > 1) {
                        for (let k = 0; k < response1.data[name].data.length; k++) {
                          let str = response1.data[name].data[k].timestamp;
                          
                          p.push([shijianchuo(str.substring(0,13)),response1.data[name].data[k].float_val]); 
                        }
                      }
                      p.push([date2.getTime(), response1.data[name].data[response1.data[name].data.length-1].float_val]);
                    }
                    if(response1.data[name].data[0].num_val != null ){
                      p.push([date1.getTime(), null]);
                      if (response1.data[name].data[0].num_val != null && response1.data[name].data.length > 1) {
                        for (let k = 0; k < response1.data[name].data.length; k++) {
                          let str = response1.data[name].data[k].timestamp;
                          
                          p.push([shijianchuo(str.substring(0,13)),response1.data[name].data[k].num_val]); 
                        }
                      }
                      p.push([date2.getTime(), response1.data[name].data[response1.data[name].data.length-1].num_val]);
                    }
                    
                  }
                  
                  _this.options.xAxis.title.text = response1.data[name].data[0].t;
                  _this.options.series[i].data = p;
                }
                _this.queryDisabled = false;
                _this.chartLoading = false;
                alertInfo(failedPvList, emptyPvList);
                return
              })
            .catch(function (error) {
                 _this.queryDisabled = false;
            });
        function shijianchuo(str){
          var timestamp = parseInt(str,10);
          var date = new Date(timestamp);
          return date.getTime();
        }
        function alertInfo(failedPvList, emptyPvList) {
          if (failedPvList.length !== 0) {
            let str = "";
            for (let j = 0; j < failedPvList.length; j++) {
              if (j < 10) {
                str += failedPvList[j] + "\n";
                continue
              }
              if (j === 10) {
                str += '等' + failedPvList.length + '个PV';
                break;
              }
            }
            _this.$notify.error({
              title: 'error',
              message: '查询' + str + "失败",
              position: 'top-right',
              offset: 400,
              duration: 3000
            })
          }
          if (emptyPvList.length !== 0) {
            let str = "";
            for (let j = 0; j < emptyPvList.length; j++) {
              if (j < 10) {
                str += emptyPvList[j] + "\n";
                continue
              }
              if (j === 10) {
                str += '等' + emptyPvList.length + '个PV';
                break;
              }
            }
            _this.$notify.error({
              title: 'error',
              message: str + "查询结果为空",
              position: 'top-right',
              offset: 400,
              duration: 3000
            })
          }
        }
      },
      queryLive123: function (date1,date2) {
        let _this = this;
        if (this.groups.length == 1 && (this.groups[0].pvs.length === 1 && this.groups[0].pvs[0] == '')) {
          return;
        }
        // if(flag == 'select'){
        //   this.switchValue2 = true;
        // }else{
        //   this.switchValue2 = false;
        // }
        if (this.daSourceValue !== "Oracle" && this.ppValue === "") {
          this.$confirm("请选择需要查询的Aggregate Type", "提示", {
            showCancelButton: false,
            showConfirmButton: false,
          })
          return;
        }
        let count = 0;
        // this.options.yAxis = [];
        // this.options.series = [];
        this.checkedPvList = [];
        // let date1 = new Date(this.value5[0]);
        // let date2 = new Date(this.value5[1]);
        // if(this.switchValue3 &&  this.timeMin && this.timeMax){
        //   date1 = new Date(this.timeMin);
        //   date2 = new Date(this.timeMax);
        // }
        let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
        let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
        this.queryDisabled = true;
        this.chartLoading = false;
        let pvList = "";
        let checkedPvList = [];
        for (let i = 0; i < this.groups.length; i++) {
          if (this.groups[i].pvs[0].name === '') {
            this.$confirm("请输入需要查询的PV", "提示", {
              showCancelButton: false,
              showConfirmButton: false,
            })
            this.chartLoading = false;
            this.queryDisabled = false;
            return;
          }
        }
        // for (let i = 0; i < this.groups.length; i++) {
        //   let yType = this.groups[i].logCheck ? "logarithmic" : "linear";
        //   this.options.yAxis.push({
        //     showFirstLabel: true,
        //     showLastLabel: true,
        //     // gridLineDashStyle:'ShortDash',
        //     gridLineWidth: 0,
        //     title: {
        //       text: null,
        //       style: {
        //         color: "black",
        //         fontWeight: 1000
        //       }
        //     },
        //     type: yType,
        //     opposite: false,
        //     lineWidth: 2
        //   })
        //   this.$axios.get('/hlsTS/pvunit/' + this.groups[i].pvs[0].name)
        //     .then(function (response) {
        //       if (response.data === null || response.data == "unknown") {
        //         _this.options.yAxis[i].title.text = _this.groups[i].pvs[0].name
        //       } else {
        //         _this.options.yAxis[i].title.text = response.data
        //       }
        //     })
        // }
        for (let i = 0; i < this.groups.length; i++) {
          for (let j = 0; j < this.groups[i].pvs.length; j++) {
            if (this.groups[i].pvs[j].name !== '') {
              pvList = pvList + this.groups[i].pvs[j].name + "@";
              checkedPvList.push(this.groups[i].pvs[j].name);
              count++;
              // this.options.series.push({
              //   name: _this.groups[i].pvs[j].name,
              //   data: null,
              //   yAxis: i,
              //   type: 'line',
              //   lineWidth: 1.5
              // })
            }
          }
        }
        let failedPvList = []
        let emptyPvList = []
        
            //this.$axios.get("/hlsTS/history/nameMap/" + pvList  + '/' + " " + "/" + time1 + "/" + time2)
            this.$axios.post("/hlsTS/history/nameMap",{
               pvList: pvList,
               type: " ",        // 保留原来的空字符串
               startTime: time1,
               endTime: time2
            }).then(function (response1) {
                // _this.options.xAxis.title.text= 'Time';
                if (response1.status !== 200) {
                  _this.$notify.error({
                    title: '错误',
                    message: 'PV' + _this.groups[i].pvs[j].name + "请求出现异常",
                    position: 'top-right',
                    offset: 400,
                    duration: 3000
                  });
                  _this.queryDisabled = false;
                  _this.chartLoading = false;
                  return;
                }
                if (response1.data == null) {
                  _this.$notify.error({
                    title: '错误',
                    message: 'PV ' + name + " 查询结果为空",
                    position: 'top-right',
                    offset: 400,
                    duration: 3000
                  });
                  if (--count === 0) {
                    _this.queryDisabled = false;
                    _this.chartLoading = false;
                  }
                  return;
                }
                for (let i = 0; i < checkedPvList.length; i++) {
                  let name = checkedPvList[i];
                  //let index = _this.dianping.indexOf(name);
                  //if(index !== -1)
                  if(response1.data[name].is_state){
                    _this.options.series[i].step = 'left';
                  }else{
                    _this.options.series[i].step = '';
                  }
                  if (response1.data[name].data == null || response1.data[name].data.length === 0) {
                    emptyPvList.push(name)
                    continue;
                  }
                  let p = new Array();
                  date1.setMilliseconds(0);
                  date2.setMilliseconds(999);
                  if(shijianchuo(response1.data[name].data[0].timestamp.substring(0,13)) <= date1.getTime()){
                    if(response1.data[name].data[0].float_val != null){
                      p.push([date1.getTime(), response1.data[name].data[0].float_val]);
                      if (response1.data[name].data[0].float_val != null) {
                        for (let k = 1; k < response1.data[name].data.length - 1; k++) {
                          let str = response1.data[name].data[k].timestamp;
                          
                          p.push([shijianchuo(str.substring(0,13)),response1.data[name].data[k].float_val]); 
                        }
                      }
                      p.push([date2.getTime(), response1.data[name].data[response1.data[name].data.length-1].float_val]);
                    }
                    if(response1.data[name].data[0].num_val != null){
                      p.push([date1.getTime(), response1.data[name].data[0].num_val]);
                      if (response1.data[name].data[0].num_val != null) {
                        for (let k = 1; k < response1.data[name].data.length - 1; k++) {
                          let str = response1.data[name].data[k].timestamp;
                          
                          p.push([shijianchuo(str.substring(0,13)),response1.data[name].data[k].num_val]); 
                        }
                      }
                      p.push([date2.getTime(), response1.data[name].data[response1.data[name].data.length-1].num_val]);
                    }
                    
                  }else if(shijianchuo(response1.data[name].data[0].timestamp.substring(0,13)) > date1.getTime()){
                    if(response1.data[name].data[0].float_val != null){
                      p.push([date1.getTime(), null]);
                      if (response1.data[name].data[0].float_val != null && response1.data[name].data.length > 1) {
                        for (let k = 0; k < response1.data[name].data.length; k++) {
                          let str = response1.data[name].data[k].timestamp;
                          
                          p.push([shijianchuo(str.substring(0,13)),response1.data[name].data[k].float_val]); 
                        }
                      }
                      p.push([date2.getTime(), response1.data[name].data[response1.data[name].data.length-1].float_val]);
                    }
                    if(response1.data[name].data[0].num_val != null){
                      p.push([date1.getTime(), null]);
                      if (response1.data[name].data[0].num_val != null && response1.data[name].data.length > 1) {
                        for (let k = 0; k < response1.data[name].data.length; k++) {
                          let str = response1.data[name].data[k].timestamp;
                          
                          p.push([shijianchuo(str.substring(0,13)),response1.data[name].data[k].num_val]); 
                        }
                      }
                      p.push([date2.getTime(), response1.data[name].data[response1.data[name].data.length-1].num_val]);
                    }
                    
                  }
                  
                  _this.options.xAxis.title.text = response1.data[name].data[0].t;
                  _this.options.series[i].data = p;
                }
                _this.queryDisabled = false;
                _this.chartLoading = false;
                alertInfo(failedPvList, emptyPvList);
                return
              })
            .catch(function (error) {
                 _this.queryDisabled = false;
            });
        function shijianchuo(str){
          var timestamp = parseInt(str,10);
          var date = new Date(timestamp);
          return date.getTime();
        }
        function alertInfo(failedPvList, emptyPvList) {
          if (failedPvList.length !== 0) {
            let str = "";
            for (let j = 0; j < failedPvList.length; j++) {
              if (j < 10) {
                str += failedPvList[j] + "\n";
                continue
              }
              if (j === 10) {
                str += '等' + failedPvList.length + '个PV';
                break;
              }
            }
            _this.$notify.error({
              title: 'error',
              message: '查询' + str + "失败",
              position: 'top-right',
              offset: 400,
              duration: 3000
            })
          }
          if (emptyPvList.length !== 0) {
            let str = "";
            for (let j = 0; j < emptyPvList.length; j++) {
              if (j < 10) {
                str += emptyPvList[j] + "\n";
                continue
              }
              if (j === 10) {
                str += '等' + emptyPvList.length + '个PV';
                break;
              }
            }
            _this.$notify.error({
              title: 'error',
              message: str + "查询结果为空",
              position: 'top-right',
              offset: 400,
              duration: 3000
            })
          }
        }
      },
      clearInter:function(){
        if(this.timer){
          clearInterval(this.timer);   
        }
      },
      clickItem:function(item){
        console.log(item)
        let _this = this;
        this.$axios.get("/hlsTS/history_arr/name/"+ item.pvName + "/" + this.time3 + "/" + item.nanosecs)
              .then((response)=>{
                let data = response.data;
                let arr = []
                for(let i = 0;i < data.length; i++){
                  arr.push([i,parseInt(data[i])])
                }
                _this.options.xAxis.opposite = true;
                _this.options.chart.marginTop = 50;
                _this.options.xAxis.title.text = '';
                _this.options.exporting.enabled = false;
                _this.options.series[0].name = '';
                 _this.options.series[0].data = arr;

                 
              })
      }
    },
    destroyed() {
      clearInterval(this.timer);
    }
  }
</script>

<style scoped>
/deep/.el-checkbox .el-checkbox__label{
  padding-left: 2px!important;
}
/deep/.el-button+.el-button{
  margin-left: 0px!important;
}
.timeline {
    margin: 0;
    font-size: 14px;
    list-style: none;
    display: inline-block;
}
.timeline-item {
    position: relative;
    padding-bottom: 0px;
    float: left;
    width:40px;
}
.timeline-tail {
    width: 36px;
    position: absolute;
    left: 4px;
    height: 100%;
    border-top: 2px solid #e4e7ed;
}
.timeline-dot {
    position: absolute;
    /* background-color: #e4e7ed; */
    background-color: red;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    left: -1px;
    width: 12px;
    height: 12px;
    top:-3px;
}
.timeline-content {
    position: relative;
    top: 12px;
    left: -15px;
}
.timeline-item:last-child .timeline-tail{
  width: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/page/activePublic/userdefinedquery.vue